import { useEffect } from "react"

function NFTView() {
    useEffect(() => {
      document.title = "NFTs - KAXAA Wallet"
    }, [])

    const nfts = [
      {
        name: "CryptoPunk #1234",
        collection: "CryptoPunks",
        image: "/placeholder.svg",
      },
      {
        name: "Bored Ape #5678",
        collection: "Bored Ape Yacht Club",
        image: "/placeholder.svg",
      },
    ]
  
    return (
      <div className="nft-view">
        <div className="nft-card">
          <div className="nft-header">
            <h2>NFT Collection</h2>
            <button className="import-button">Import NFT</button>
          </div>
  
          {nfts.length > 0 ? (
            <div className="nft-grid">
              {nfts.map((nft, index) => (
                <div key={index} className="nft-item">
                  <div className="nft-image"></div>
                  <div className="nft-info">
                    <h3>{nft.name}</h3>
                    <p>{nft.collection}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-icon">🖼️</div>
              <h3>No NFTs Found</h3>
              <p>Import your first NFT to get started</p>
              <button className="import-button">➕ Import NFT</button>
            </div>
          )}
        </div>
      </div>
    )
  }
  
  export default NFTView
  